import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { FileLogger } from "@comunicare/comunicare-helper";
import { of } from "rxjs";
import { catchError } from "rxjs/operators";
import { PractitionerService } from "../../providers/practitioner.service";
import { ConfirmResetPasswordDialogComponent } from "../confirm-reset-password-dialog/confirm-reset-password-dialog.component";

export interface TogglePractitionerDialogData {
  currentUser: { mail: string; name: string; firstname: string; caremateId: string };
  activate: boolean;
}

@Component({
  selector: "app-confirm-toggle-practitioner-dialog",
  templateUrl: "./confirm-toggle-practitioner-dialog.component.html",
  styleUrls: ["./confirm-toggle-practitioner-dialog.component.scss"],
})
export class ConfirmTogglePractitionerDialogComponent {
  public loading = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: TogglePractitionerDialogData,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<ConfirmTogglePractitionerDialogComponent>,
    private practitionerService: PractitionerService
  ) {}

  public closeModal(): void {
    this.dialogRef.close(false);
  }

  public confirm(resetPassword = false): void {
    this.loading = true;
    this.practitionerService
      .setPractitionerActivation(this.data.currentUser.caremateId, this.data.activate)
      .pipe(
        catchError((error) => {
          FileLogger.error("ConfirmTogglePractitionerDialogComponent", "confirm", error);
          return of(null);
        })
      )
      .subscribe((result) => {
        this.loading = false;
        const success = result !== null;
        this.dialogRef.close(success);
        if (success && resetPassword) {
          this.openResetPasswordDialog();
        }
      });
  }

  private openResetPasswordDialog(): void {
    this.dialog.open(ConfirmResetPasswordDialogComponent, {
      width: "450px",
      height: "250px",
      data: {
        currentUser: this.data.currentUser,
        preference: false,
      },
    });
  }
}
